import React from "react";
import { Button, Form } from "react-bootstrap";
import { WizardFormData } from "./types";

const StepBusinessInfo: React.FC<{
  formData: WizardFormData;
  onChange: (updates: Partial<WizardFormData>) => void;
  onBack: () => void;
  onNext: () => void;
}> = ({ formData, onChange, onBack, onNext }) => {
  const canProceed = formData.websiteUrl.trim() && formData.logoUrl.trim();

  return (
    <div className="wizard-card">
      <div className="wizard-header">Business Info</div>
      <div className="wizard-description">
        Provide some basic information about your company.
      </div>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="wizard-websiteUrl">URL to Startup or App</Form.Label>
        <Form.Control
          id="wizard-websiteUrl"
          name="websiteUrl"
          type="url"
          placeholder="https://yourapp.com"
          value={formData.websiteUrl}
          onChange={(e) => onChange({ websiteUrl: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="wizard-contactEmail">Contact Email (optional)</Form.Label>
        <Form.Control
          id="wizard-contactEmail"
          name="contactEmail"
          type="email"
          placeholder="hello@yourapp.com"
          value={formData.contactEmail}
          onChange={(e) => onChange({ contactEmail: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="wizard-logoUrl">URL to Company Logo</Form.Label>
        <Form.Control
          id="wizard-logoUrl"
          name="logoUrl"
          type="url"
          placeholder="https://yourapp.com/logo.png"
          value={formData.logoUrl}
          onChange={(e) => onChange({ logoUrl: e.target.value })}
        />
      </Form.Group>

      <div className="wizard-nav">
        <Button variant="outline-secondary" onClick={onBack}>
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!canProceed}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default StepBusinessInfo;
